module.exports = __webpack_public_path__ + "img/img10.1a7eed7e.svg";